import styled from "styled-components/macro";

export const ShadowBottom = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
`;
